// extracted by mini-css-extract-plugin
export var acitonButtons = "_go-0";
export var additionalIcon = "_go-f";
export var block = "_go-1";
export var blockContent = "_go-7";
export var blockDescription = "_go-8";
export var blockIcon = "_go-9";
export var blockTitle = "_go-6";
export var border = "_go-a";
export var center = "_go-l";
export var edge = "_go-b";
export var edgeLabel = "_go-c";
export var edgePath = "_go-d";
export var error = "_go-e";
export var flowchart = "_go-g";
export var flowchartContent = "_go-h";
export var highlighted = "_go-3";
export var hover = "_go-4";
export var icon = "_go-i";
export var left = "_go-m";
export var navButton = "_go-j";
export var navButtons = "_go-k";
export var right = "_go-n";
export var selected = "_go-2";
export var small = "_go-5";